import { createSelector, createSlice } from '@reduxjs/toolkit'

export const SIMULATOR_KEY = 'simulator'

export interface SimulatorState {
  activeTab: number
  selectedTeamId?: number
  selectedGameSimulationId?: number
}

export const initialSimulatorState: SimulatorState = {
  activeTab: 0,
  selectedTeamId: undefined,
  selectedGameSimulationId: undefined,
}

export const simulatorSlice = createSlice({
  name: SIMULATOR_KEY,
  initialState: initialSimulatorState,
  reducers: {
    updateActiveTab: (state: SimulatorState, { payload }: { payload: number }) => {
      state.activeTab = payload
    },
    setSelectedTeamId: (state: SimulatorState, { payload }: { payload: number | undefined }) => {
      state.selectedTeamId = payload
    },
    setSelectedGameSimulationId: (state: SimulatorState, { payload }: { payload: number | undefined }) => {
      state.selectedGameSimulationId = payload
    },
  },
})

export const simulatorReducer = simulatorSlice.reducer
export const simulatorActions = simulatorSlice.actions

export const getSimulatorState = (rootState: { [x: string]: SimulatorState }): SimulatorState => {
  return rootState[SIMULATOR_KEY]
}

export const simulatorSelectors = {
  getActiveTab: createSelector(getSimulatorState, (state: SimulatorState) => state.activeTab),
  getSelectedTeamId: createSelector(getSimulatorState, (state: SimulatorState) => state.selectedTeamId),
  getSelectedGameSimulationId: createSelector(
    getSimulatorState,
    (state: SimulatorState) => state.selectedGameSimulationId
  ),
}
